import API from "@/redux/api/API";
import APIFile from "@/redux/api/APIFile";

const AR_SHAPES_BASE_PATH = "/api/ar-shapes";

export const getAllARShapesApi = async () => {
  try {
    const response = await API.get(AR_SHAPES_BASE_PATH);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postARShapeApi = async (payload) => {
  try {
    const response = await API.post(AR_SHAPES_BASE_PATH, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getARShapeByIdApi = async (arShapeId) => {
  try {
    const response = await API.get(`${AR_SHAPES_BASE_PATH}/${arShapeId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateARShapeApi = async (payload) => {
  const { arShapeId, ...body } = payload || {};

  try {
    const response = await API.put(`${AR_SHAPES_BASE_PATH}/${arShapeId}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteARShapeApi = async (arShapeId) => {
  try {
    const response = await API.delete(`${AR_SHAPES_BASE_PATH}/${arShapeId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadARShapeFileApi = async (payload) => {
  const { arShapeId, file } = payload || {};
  const formData = new FormData();

  if (file) {
    formData.append("file", file, file?.name || "shape-file");
  }

  try {
    const response = await APIFile.post(
      `${AR_SHAPES_BASE_PATH}/${arShapeId}/upload`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
